import {
	requests
}from "../../../../api/agent"

export default {
	create                : (params) => requests.post('/ReDistrict/create', params),
	update                : (params) => requests.post('/ReDistrict/update', params),
	delete                : (params) => requests.getWithParams('/ReDistrict/delete', params),
	restore               : (params) => requests.getWithParams('/ReDistrict/restore', params),
	getPaged              : (params) => requests.getWithParams('/ReDistrict/getPaged', params),
	getPagedAudit         : (params) => requests.getWithParams('/ReDistrict/getPagedAudit', params),
	getPagedAll           : (params) => requests.getWithParams('/ReDistrict/getPagedAll', params),
	getList               : (params) => requests.getWithParams('/ReDistrict/getList', params),
	getListActualByRegion : (params) => requests.getWithParams('/ReDistrict/getListActualByRegion', params)
}